import { z } from 'my-zod'
import { addOnModel } from './add-on-model'
import { customerOrdersModel } from '../../customer-operations/customer-order'

export const addOnSystemView = addOnModel.augment({
  // customerOrderShortId: customerOrdersModel.shape.shortId
})

export type addOnSystemView = z.infer<typeof addOnSystemView>
